<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="新增成员"
    >
        <el-tabs v-model="status" @tab-click="active" ref="tabs">
            <el-tab-pane
                :label="item.name"
                v-for="item in statusList"
                :key="item.status"
                :name="item.status"
                :disabled="item.disabled"
            ></el-tab-pane>
        </el-tabs>
        <div class="container" v-show="status == '0'">
            <el-form ref="addForm" :model="addForm" label-width="100px">
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="真实姓名"
                            size="small"
                            :rules="[
                                { required: true, message: '请输入真实姓名' }
                            ]"
                            prop="name"
                        >
                            <el-input
                                clearable
                                placeholder="请输入真实姓名"
                                maxlength="30"
                                size="small"
                                v-model="addForm.name"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="联系电话"
                            size="small"
                            :rules="[
                                { required: true, message: '请输入联系电话' },
                                {
                                    type: 'number',
                                    message: '联系电话必须为数字'
                                }
                            ]"
                            prop="phone"
                        >
                            <el-input
                                clearable
                                placeholder="请输入联系电话"
                                maxlength="30"
                                size="small"
                                v-model.number="addForm.phone"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="所在部门"
                            size="small"
                            :rules="[
                                { required: true, message: '请选择所在部门' }
                            ]"
                            prop="depart_list"
                        >
                            <el-cascader
                                clearable
                                filterable
                                :options="departList"
                                :props="props"
                                v-model="addForm.depart_list"
                                style="width:100%"
                                placeholder="请选择所在部门"
                            >
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="电子邮箱" size="small">
                            <el-input
                                clearable
                                placeholder="请输入电子邮箱"
                                maxlength="50"
                                size="small"
                                v-model="addForm.email"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="入职日期"
                            size="small"
                            :rules="[
                                { required: true, message: '请选择入职日期' }
                            ]"
                            prop="entry_date"
                        >
                            <el-date-picker
                                v-model="addForm.entry_date"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                @change="getEffectDate"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="离职日期" size="small">
                            <el-date-picker
                                v-model="addForm.resign_date"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                :disabled="!addForm.entry_date"
                                :picker-options="controlTime"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="转正日期"
                            :rules="[
                                { required: true, message: '请选择转正日期' }
                            ]"
                            prop="effect_date"
                            size="small"
                        >
                            <el-date-picker
                                v-model="addForm.effect_date"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                :disabled="!addForm.entry_date"
                                :picker-options="controlTime"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <!-- <el-col :span="12">
            <el-form-item label="民族"
                          size="small">
              <el-input clearable
                        placeholder="请输入民族"
                        maxlength="30"
                        size="small"
                        v-model="addForm.nation">
              </el-input>
            </el-form-item>
          </el-col> -->
                    <el-col :span="12">
                        <el-form-item
                            label="性别"
                            size="small"
                            style="text-align:left"
                        >
                            <el-radio v-model="addForm.sex" :label="1"
                                >男</el-radio
                            >
                            <el-radio v-model="addForm.sex" :label="2"
                                >女</el-radio
                            >
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="籍贯" size="small">
                            <el-input
                                clearable
                                placeholder="请输入籍贯"
                                maxlength="30"
                                size="small"
                                v-model="addForm.hometown"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="学历" size="small">
                            <el-select
                                v-model="addForm.education"
                                size="small"
                                placeholder="请选择学历"
                            >
                                <el-option
                                    v-for="item in educationList"
                                    :key="item"
                                    :label="item"
                                    :value="item"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="专业" size="small">
                            <el-input
                                clearable
                                placeholder="请输入专业"
                                maxlength="30"
                                size="small"
                                v-model="addForm.speciality"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="紧急联系人" size="small">
                            <el-input
                                clearable
                                placeholder="请输入紧急联系人"
                                maxlength="30"
                                size="small"
                                v-model="addForm.urgent_person"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="紧急联系电话" size="small">
                            <el-input
                                clearable
                                placeholder="请输入紧急联系电话"
                                maxlength="11"
                                size="small"
                                type="number"
                                v-model.number="addForm.urgent_phone"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="出生日期" size="small">
                            <el-date-picker
                                v-model="addForm.birthday"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="英文名称" size="small">
                            <el-input
                                clearable
                                placeholder="请输入英文名称"
                                maxlength="30"
                                size="small"
                                v-model="addForm.name_en"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="职位" size="small">
                            <!-- <el-input clearable
                        placeholder="请输入职位"
                        maxlength="30"
                        size="small"
                        v-model="addForm.position">
              </el-input> -->
                            <el-select
                                v-model="addForm.position"
                                clearable
                                placeholder="请选择职位"
                                filterable
                                size="small"
                            >
                                <el-option
                                    v-for="item in typeList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="是否已婚"
                            size="small"
                            style="text-align:left"
                        >
                            <el-radio v-model="addForm.marriage" :label="1"
                                >已婚</el-radio
                            >
                            <el-radio v-model="addForm.marriage" :label="0"
                                >未婚</el-radio
                            >
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="联系地址" size="small">
                            <el-input
                                clearable
                                placeholder="请输入联系地址"
                                maxlength="30"
                                size="small"
                                v-model="addForm.address"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="个人简介" size="small">
                            <el-input
                                clearable
                                placeholder="请输入个人简介"
                                maxlength="30"
                                size="small"
                                :rows="5"
                                v-model="addForm.description"
                                type="textarea"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="container" v-show="status == '1'">
            <div class="table tableSchool">
                <el-form
                    ref="schoolForm"
                    :model="schoolForm"
                    label-width="0"
                    :inline="true"
                >
                    <el-table border :data="schoolData" highlight-current-row>
                        <el-table-column
                            label="学校"
                            property="school"
                            align="center"
                            width="180"
                        >
                            <template slot-scope="scope">
                                <div v-if="scope.row.id">
                                    {{ scope.row.school }}
                                </div>
                                <div class="newItem" v-else>
                                    <el-form-item
                                        :rules="[
                                            {
                                                required: true,
                                                message: '请输入学校名称'
                                            }
                                        ]"
                                        prop="school"
                                        size="small"
                                    >
                                        <el-input
                                            clearable
                                            placeholder="请输入学校名称"
                                            maxlength="30"
                                            size="small"
                                            v-model="schoolForm.school"
                                        >
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="时间"
                            align="center"
                            width="300"
                        >
                            <template slot-scope="scope">
                                <div v-if="scope.row.id">
                                    {{ scope.row.start_date }} -
                                    {{ scope.row.end_date }}
                                </div>
                                <div class="newItem" v-else>
                                    <el-form-item
                                        :rules="[
                                            {
                                                required: true,
                                                message: '请选择开始与结束日期'
                                            }
                                        ]"
                                        prop="time"
                                        size="small"
                                    >
                                        <el-date-picker
                                            v-model="schoolForm.time"
                                            type="monthrange"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                            size="small"
                                            @change="handleTimeChange"
                                            value-format="yyyy-MM"
                                            format="yyyy-MM"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="年限" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.id">
                                    {{ scope.row.years }}
                                </div>
                                <div class="newItem" v-else>
                                    -
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="专业"
                            align="center"
                            width="240"
                        >
                            <template slot-scope="scope">
                                <div v-if="scope.row.id">
                                    {{ scope.row.speciality }}
                                </div>
                                <div class="newItem" v-else>
                                    <el-form-item
                                        :rules="[
                                            {
                                                required: true,
                                                message: '请输入专业'
                                            }
                                        ]"
                                        prop="speciality"
                                        size="small"
                                    >
                                        <el-input
                                            clearable
                                            placeholder="请输入专业"
                                            maxlength="30"
                                            size="small"
                                            v-model="schoolForm.speciality"
                                        >
                                        </el-input>
                                    </el-form-item>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="scope.row.id"
                                    type="text"
                                    size="small"
                                    @click="removeSchoolItem(scope.row)"
                                    style="color:red"
                                    >移除</el-button
                                >
                                <el-button
                                    v-else
                                    type="text"
                                    size="small"
                                    @click="commitSchoolItem(scope.row)"
                                    >保存</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
        </div>
        <div class="container" v-show="status == '2'">
            <div class="table tableHealth">
                <el-form
                    ref="healthForm"
                    :model="healthForm"
                    label-width="0"
                    :inline="true"
                >
                    <el-table
                        border
                        :data="healthData"
                        v-loading="loading"
                        highlight-current-row
                    >
                        <el-table-column label="年份" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.id">
                                    {{ scope.row.year }}
                                </div>
                                <div class="newItem" v-else>
                                    <el-form-item
                                        :rules="[
                                            {
                                                required: true,
                                                message: '请选择年份'
                                            }
                                        ]"
                                        prop="year"
                                        size="small"
                                    >
                                        <el-date-picker
                                            v-model="healthForm.year"
                                            type="year"
                                            placeholder="选择年"
                                            size="small"
                                            value-format="yyyy"
                                            format="yyyy"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="健康状况" align="center">
                            <template slot-scope="scope">
                                <div v-if="scope.row.id">
                                    {{
                                        scope.row.status == 1
                                            ? "正常"
                                            : "不健康"
                                    }}
                                </div>
                                <div class="newItem" v-else>
                                    <el-form-item
                                        :rules="[
                                            {
                                                required: true,
                                                message: '请选择健康状况'
                                            }
                                        ]"
                                        prop="status"
                                        size="small"
                                    >
                                        <el-radio
                                            v-model="healthForm.status"
                                            label="1"
                                            size="small"
                                            >正常</el-radio
                                        >
                                        <el-radio
                                            v-model="healthForm.status"
                                            label="2"
                                            size="small"
                                            >不健康</el-radio
                                        >
                                    </el-form-item>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="scope.row.id"
                                    type="text"
                                    size="small"
                                    @click="removeHealthItem(scope.row)"
                                    style="color:red"
                                    >移除</el-button
                                >
                                <el-button
                                    v-else
                                    type="text"
                                    size="small"
                                    @click="commitHealthItem(scope.row)"
                                    >保存</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
        </div>
        <div class="container" v-show="status == '3'">
            <el-form ref="bankForm" :model="bankForm" label-width="120px">
                <el-row>
                    <el-col :span="14">
                        <el-form-item
                            label="开户银行"
                            size="small"
                            :rules="[
                                { required: true, message: '请输入开户银行' }
                            ]"
                            prop="bank_name"
                        >
                            <el-input
                                clearable
                                placeholder="请输入开户银行"
                                maxlength="30"
                                size="small"
                                v-model="bankForm.bank_name"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="14">
                        <el-form-item
                            label="银行账号"
                            size="small"
                            :rules="[
                                { required: true, message: '请输入银行账号' }
                            ]"
                            prop="bank_account"
                        >
                            <el-input
                                clearable
                                placeholder="请输入银行账号"
                                maxlength="30"
                                size="small"
                                v-model="bankForm.bank_account"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="14">
                        <el-form-item
                            label="社保卡号"
                            size="small"
                            :rules="[
                                { required: true, message: '请输入社保卡号' }
                            ]"
                            prop="social_card"
                        >
                            <el-input
                                clearable
                                placeholder="请输入社保卡号"
                                maxlength="30"
                                size="small"
                                v-model="bankForm.social_card"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="14">
                        <el-form-item label="公积金号码" size="small">
                            <el-input
                                clearable
                                placeholder="请输入公积金号码"
                                maxlength="30"
                                size="small"
                                v-model="bankForm.fund_card"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="身份证正反面"
                            size="small"
                            :rules="[{ required: true, message: '请上传图片' }]"
                            prop="id_card_file_z"
                        >
                            <imgUploadZ
                                :images.sync="bankForm.id_card_file_z"
                                ref="uploadRef"
                                :width="'300'"
                                :height="'190'"
                                :limit="1"
                                :multiple="false"
                                :text="`正面`"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            size="small"
                            label-width="40"
                            :rules="[{ required: true, message: '请上传图片' }]"
                            prop="id_card_file_f"
                        >
                            <imgUploadF
                                :images.sync="bankForm.id_card_file_f"
                                ref="uploadRef"
                                :width="'300'"
                                :height="'190'"
                                :limit="1"
                                :multiple="false"
                                :text="`反面`"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="14">
                        <el-form-item label="身份证号码" size="small">
                            <el-input
                                clearable
                                placeholder="请输入身份证号码"
                                maxlength="30"
                                size="small"
                                v-model="bankForm.identity"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                v-if="this.status == '0' || this.status == '3'"
                type="primary"
                @click="save"
                >保存</el-button
            >
            <el-button size="small" type="primary" @click="addVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import * as api from "@/http/api.js";
import { mapState } from "vuex";
import imgUpload from "@/comon/components/imgUpload";
import {getEffectDate} from "@/http/oaApi.js";
import util from "@/utils/util.js";
export default {
    data() {
        return {
            statusList: [
                { name: "填写基本信息", status: "0", disabled: false },
                { name: "填写教育背景", status: "1", disabled: true },
                { name: "填写健康状况", status: "2", disabled: true },
                { name: "银行卡信息", status: "3", disabled: true }
            ],
            status: "0",
            addForm: {
                address: "",
                authority: [],
                avatar: "",
                bank_account: "",
                bank_name: "",
                birthday: "",
                depart_list: "",
                depart_name: "",
                description: null,
                education: "",
                effect_date: "",
                email: "",
                entry_date: "",
                formal: 2,
                formal_cn: "",
                fund_card: "",
                hometown: "",
                id: "",
                id_card_file_f: [],
                id_card_file_z: [],
                identity: "",
                job_no: "",
                marriage: 1,
                marriage_cn: "",
                name: "",
                name_en: "",
                parent_avatar: "",
                parent_name: "",
                parent_user_id: "",
                phone: "",
                position: "",
                resign_date: "",
                role_name: false,
                sex: 1,
                sex_cn: "",
                social_card: "",
                speciality: "",
                status: 1,
                status_cn: "",
                tobe_confirmed_num: 0,
                tobe_pending_num: 0,
                urgent_person: "",
                urgent_phone: "",
                work_age: "",
                work_day: 0,
                work_year: 0
            },
            user_id: "",
            schoolForm: {
                school: "",
                time: "",
                speciality: "",
                start_date: "",
                end_date: ""
            },
            schoolData: [
                {
                    school: "",
                    speciality: "",
                    start_date: "",
                    end_date: "",
                    years: ""
                }
            ],
            healthForm: {
                status: "1",
                year: ""
            },
            healthData: [
                {
                    year: "",
                    status: 1
                }
            ],

            props: {
                value: "id",
                label: "name",
                children: "child",
                checkStrictly: true
            },
            departList: [],

            bankForm: {
                social_card: "",
                fund_card: "",
                bank_name: "",
                bank_account: "",
                id_card_file_z: [],
                id_card_file_f: [],
                identity: "",
                name: ""
            },
            controlTime: {
                disabledDate: time => {
                    return (
                        time.getTime() <
                        new Date(
                            Date.parse(
                                this.addForm.entry_date.replace(/-/g, "/")
                            )
                        )
                    );
                }
            },
            typeList: []
        };
    },
    methods: {
        save() {
            if (this.status == "0") {
                this.$refs["addForm"].validate(valid => {
                    if (valid) {
                        oaApi
                            .user(
                                this.addForm,
                                this.user_id ? "put" : "post",
                                this.user_id ? this.user_id : ""
                            )
                            .then(res => {
                                if (res) {
                                    this.user_id = res.data.id;
                                    this.$message.success(
                                        this.user_id ? "修改成功" : "创建成功"
                                    );
                                    this.$parent.userGet();
                                    this.addVisible = false;
                                    this.status = "1";
                                }
                            });
                    }
                });
            } else if (this.status == "3") {
                this.$refs["bankForm"].validate(valid => {
                    if (valid) {
                        oaApi
                            .addBank(
                                {
                                    ...this.bankForm,
                                    user_id: this.user_id
                                },
                                "post"
                            )
                            .then(res => {
                                if (res) {
                                    this.$message.success(
                                        this.user_id ? "修改成功" : "保存成功"
                                    );
                                    this.$parent.userGet();
                                    this.addVisible = false;
                                }
                            });
                    }
                });
            }
        },
        /**
         *  获取组织架构信息
         */
        depart() {
            api.depart({}, "get").then(res => {
                if (res) {
                    this.departList = res.data;
                }
            });
        },
        closeDialog() {
            if (this.status == "0") {
                this.$refs["addForm"].clearValidate();
                // this.$refs["addForm"].resetFields();
            } else if (this.status == "1") {
                this.$refs["schoolForm"].clearValidate();
                // this.$refs["schoolForm"].resetFields();
            } else if (this.status == "2") {
                this.$refs["healthForm"].clearValidate();
                // this.$refs["healthForm"].resetFields();
            } else if (this.status == "3") {
                this.$refs["bankForm"].clearValidate();
                // this.$refs["bankForm"].resetFields();
            }
            this.addForm = {
                address: "",
                authority: [],
                avatar: "",
                bank_account: "",
                bank_name: "",
                birthday: "",
                depart_list: "",
                depart_name: "",
                description: null,
                education: "",
                effect_date: "",
                email: "",
                entry_date: "",
                formal: 2,
                formal_cn: "",
                fund_card: "",
                hometown: "",
                id: "",
                id_card_file_f: [],
                id_card_file_z: [],
                identity: "",
                job_no: "",
                marriage: 1,
                marriage_cn: "",
                name: "",
                name_en: "",
                parent_avatar: "",
                parent_name: "",
                parent_user_id: "",
                phone: "",
                position: "",
                resign_date: "",
                role_name: false,
                sex: 1,
                sex_cn: "",
                social_card: "",
                speciality: "",
                status: 1,
                status_cn: "",
                tobe_confirmed_num: 0,
                tobe_pending_num: 0,
                urgent_person: "",
                urgent_phone: "",
                work_age: "",
                work_day: 0,
                work_year: 0
            };
            this.schoolForm = {
                school: "",
                time: "",
                speciality: "",
                start_date: "",
                end_date: ""
            };
            this.schoolData = [
                {
                    school: "",
                    speciality: "",
                    start_date: "",
                    end_date: "",
                    years: ""
                }
            ];
            this.healthForm = {
                status: "1",
                year: ""
            };
            this.healthData = [
                {
                    year: "",
                    status: 1
                }
            ];
            this.bankForm = {
                address: "",
                authority: [],
                avatar: "",
                bank_account: "",
                bank_name: "",
                birthday: "",
                depart_list: "",
                depart_name: "",
                description: null,
                education: "",
                effect_date: "",
                email: "",
                entry_date: "",
                formal: 2,
                formal_cn: "",
                fund_card: "",
                hometown: "",
                id: "",
                id_card_file_f: [],
                id_card_file_z: [],
                identity: "",
                job_no: "",
                marriage: 1,
                marriage_cn: "",
                name: "",
                name_en: "",
                parent_avatar: "",
                parent_name: "",
                parent_user_id: "",
                phone: "",
                position: "",
                resign_date: "",
                role_name: false,
                sex: 1,
                sex_cn: "",
                social_card: "",
                speciality: "",
                status: 1,
                status_cn: "",
                tobe_confirmed_num: 0,
                tobe_pending_num: 0,
                urgent_person: "",
                urgent_phone: "",
                work_age: "",
                work_day: 0,
                work_year: 0
            };
            this.user_id = "";
            if (this.$refs.selectBtn) {
                this.$refs.selectBtn.clearHandle();
            }
            this.$emit("update:addVisible", this.addVisible);
            this.status = "0";
        },
        /**
         * 行内保存
         */
        commitSchoolItem(row) {
            this.schoolForm.user_id = this.user_id;
            this.$refs["schoolForm"].validate(valid => {
                if (valid) {
                    oaApi.school(this.schoolForm, "post").then(res => {
                        if (res) {
                            this.schoolData = [];
                            this.getSchool(this.user_id);
                        }
                    });
                }
            });
        },
        commitHealthItem(row) {
            this.healthForm.user_id = this.user_id;
            this.$refs["healthForm"].validate(valid => {
                if (valid) {
                    oaApi.health(this.healthForm, "post").then(res => {
                        if (res) {
                            this.getHealth(this.user_id);
                        }
                    });
                }
            });
        },
        getSchool(id) {
            oaApi.school({ user_id: id }, "get").then(res => {
                if (res) {
                    this.schoolData = [];
                    this.schoolData = res.data;
                    this.schoolForm = {
                        school: "",
                        speciality: "",
                        start_date: "",
                        end_date: "",
                        years: ""
                    };
                    this.schoolData.push(this.schoolForm);
                }
            });
        },
        getHealth(id) {
            oaApi.health({ user_id: id }, "get").then(res => {
                if (res) {
                    this.healthData = [];
                    this.healthData = res.data;
                    this.healthForm = {
                        year: "",
                        status: "1"
                    };
                    this.healthData.push(this.healthForm);
                }
            });
        },
        removeSchoolItem(row) {
            oaApi.school({}, "delete", row.id).then(res => {
                if (res) {
                    this.getSchool(this.user_id);
                }
            });
        },
        removeHealthItem(row) {
            oaApi.health({}, "delete", row.id).then(res => {
                if (res) {
                    this.getHealth(this.user_id);
                }
            });
        },
        // datapicker事件改变事件
        handleTimeChange(val) {
            if (val) {
                this.schoolForm.start_date = val[0];
                this.schoolForm.end_date = val[1];
            } else {
                this.schoolForm.start_date = "";
                this.schoolForm.end_date = "";
            }
        },
        active() {
            if (this.status == "1") {
                this.getSchool(this.user_id);
                // this.$nextTick(() => {
                //   this.$refs["schoolForm"].clearValidate();
                // })
            } else if (this.status == "2") {
                this.getHealth(this.user_id);
                // this.$nextTick(() => {
                //   this.$refs["healthForm"].clearValidate();
                // })
            } else if (this.status == "3") {
                this.$nextTick(() => {
                    this.$refs["bankForm"].clearValidate();
                });
            }
        },
        getRoleList() {
            oaApi.roleSelect({}, "get").then(res => {
                if (res) {
                    this.typeList = res.data;
                }
            });
        },
      /**
       * 获取转正日期
       */
      getEffectDate(){
         // alert(this.addForm.entry_date);
         // this.addForm.effect_date = this.addForm.entry_date;
        oaApi.getEffectDate({'name':'trial_day'}, "get").then(res => {
          if (res) {
            if(this.addForm.entry_date){
              if(!res.data){
                res.data = 90;
              }
              var three = util.getNewData(this.addForm.entry_date, res.data);
              this.addForm.effect_date = three;
            }
          }
        });
      },
    },
    props: {
        addVisible: Boolean,
        educationList: Array
    },
    components: {
        imgUploadZ: imgUpload,
        imgUploadF: imgUpload
    },
    computed: {
        ...mapState({
            staffList: state => state.index.staffList,

        })
    },
    created() {
        this.depart();
    },
    watch: {
        user_id() {
            if (this.user_id) {
                for (let i in this.statusList) {
                    this.statusList[i].disabled = false;
                }
            }
        },
        addVisible: {
            handler(newValue) {
                if (newValue) {
                    this.getRoleList();
                }
            },
            deep: true,
            immediate: false
        },
    }
};
</script>
<style lang="scss">
.add {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-steps {
        margin-bottom: 20px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
        .seccussImg {
            width: 80px;
            margin-top: 18px;
        }
        .seccussText {
            font-size: 18px;
            font-weight: bold;
            line-height: 2;
            margin-top: 18px;
        }
        .tableSchool,
        .tableHealth {
            .el-form-item--small.el-form-item {
                margin-bottom: 0;
            }
        }
    }
}
</style>
